import { pickGenderText } from "../utils/genderText";
import { getRecognitionLinesForProblem } from "./problemJourneyMap";

export const ENTRY_EMOTION_CARDS = [
  {
    key: "broken_heart",
    problemKey: "rel_breakup_fresh_pain",
    labels: {
      he: "הלב שלי נשבר",
      en: "My heart feels broken",
      es: "Siento el corazon roto",
    },
    recognition: {
      he: [
        "משהו בי עדיין לא מבין שזה נגמר.",
        "הראש יודע...",
        "אבל הלב עדיין מחפש אותה.",
      ],
      en: [
        "Something in me still does not understand that it is over.",
        "My head knows...",
        "But my heart still looks for her.",
      ],
      es: [
        "Algo en mi todavia no entiende que termino.",
        "La cabeza lo sabe...",
        "Pero el corazon todavia la busca.",
      ],
    },
  },
  {
    key: "overthinking",
    problemKey: "overthinking_chronic_worry",
    labels: {
      he: "אני חושב יותר מדי",
      en: "I think too much",
      es: "Pienso demasiado",
    },
    recognition: {
      he: [
        "המחשבות שלי לא עוצרות לרגע.",
        "אני מריץ שוב ושוב את אותם הדברים.",
        "וקשה לי למצוא שקט.",
      ],
      en: [
        "My thoughts do not stop for a moment.",
        "I keep running through the same things again and again.",
        "And it is hard for me to find quiet.",
      ],
      es: [
        "Mis pensamientos no paran ni un momento.",
        "Vuelvo una y otra vez a lo mismo.",
        "Y me cuesta encontrar calma.",
      ],
    },
  },
  {
    key: "lost",
    problemKey: "i_don_t_know_who_i_am_anymore",
    labels: {
      he: "אני מרגיש אבוד",
      en: "I feel lost",
      es: "Me siento perdido",
    },
    recognition: {
      he: [
        "אני לא לגמרי מבין איפה אני בתוך כל זה.",
        "משהו בי מרגיש בלי כיוון.",
        "ואני רק מנסה למצוא את עצמי שוב.",
      ],
      en: [
        "I do not fully understand where I am inside all of this.",
        "Something in me feels without direction.",
        "And I am only trying to find myself again.",
      ],
      es: [
        "No termino de entender donde estoy dentro de todo esto.",
        "Algo en mi se siente sin direccion.",
        "Y solo intento volver a encontrarme.",
      ],
    },
  },
  {
    key: "lonely",
    problemKey: "loneliness_even_when_there_are_people_around",
    labels: {
      he: "אני מרגיש לבד",
      en: "I feel alone",
      es: "Me siento solo",
    },
    recognition: {
      he: [
        "יש רגעים שאני מרגיש לבד בתוך כל זה.",
        "גם כשיש אנשים סביבי...",
        "משהו בי נשאר לבד.",
      ],
      en: [
        "There are moments when I feel alone inside all of this.",
        "Even when there are people around me...",
        "Something in me still stays alone.",
      ],
      es: [
        "Hay momentos en los que me siento solo dentro de todo esto.",
        "Incluso cuando hay gente a mi alrededor...",
        "Algo en mi se queda solo.",
      ],
    },
  },
  {
    key: "unsettled",
    problemKey: "anxiety_general",
    labels: {
      he: "משהו בי לא שקט",
      en: "Something in me is not calm",
      es: "Hay algo en mi que no esta en calma",
    },
    recognition: {
      he: [
        "משהו בי לא נרגע.",
        "גם כשבחוץ הכול נראה רגיל...",
        "בפנים משהו ממשיך לעבוד.",
      ],
      en: [
        "Something in me does not settle down.",
        "Even when everything looks normal outside...",
        "Inside, something keeps working.",
      ],
      es: [
        "Hay algo en mi que no se calma.",
        "Incluso cuando afuera todo parece normal...",
        "Por dentro algo sigue trabajando.",
      ],
    },
  },
  {
    key: "fear_losing",
    problemKey: "conditional_relationship_fear_of_abandonment",
    labels: {
      he: "אני מפחד לאבד מישהו קרוב אליי",
      en: "I am afraid of losing someone",
      es: "Tengo miedo de perder a alguien",
    },
    recognition: {
      he: [
        "יש בי פחד לאבד.",
        "גם כשעוד לא הכול נגמר...",
        "משהו בי כבר נלחץ.",
      ],
      en: [
        "There is a fear in me of losing.",
        "Even before everything is gone...",
        "Something in me is already tightening.",
      ],
      es: [
        "Hay en mi un miedo a perder.",
        "Incluso antes de que todo termine...",
        "Algo en mi ya se tensa.",
      ],
    },
  },
  {
    key: "understand_inside",
    problemKey: "loss_of_sense_of_identity_who_am_i_even_today",
    labels: {
      he: "אני רוצה להבין מה עובר עלי",
      en: "I want to understand what is happening inside me",
      es: "Quiero entender que pasa dentro de mi",
    },
    recognition: {
      he: [
        "יש בי משהו שאני עוד לא מבין.",
        "אני מרגיש שמשהו קורה בתוכי...",
        "ואני רוצה להקשיב לזה לאט.",
      ],
      en: [
        "There is something in me I still do not understand.",
        "I feel that something is happening inside me...",
        "And I want to listen to it slowly.",
      ],
      es: [
        "Hay algo en mi que todavia no entiendo.",
        "Siento que algo esta pasando dentro de mi...",
        "Y quiero escucharlo despacio.",
      ],
    },
  },
  {
    key: "closed_off",
    problemKey: "feeling_of_inner_emptiness_i_have_no_energy_for_anything",
    labels: {
      he: "אני מרגיש שאני נסגר",
      en: "I feel like something in me closed",
      es: "Siento que algo en mi se cerro",
    },
    recognition: {
      he: [
        "יש בי חלק שנסגר.",
        "אני מרגיש רחוק ממה שאני מרגיש באמת.",
        "וכמעט אין לי מילים לזה.",
      ],
      en: [
        "There is a part of me that closed down.",
        "I feel far from what I truly feel.",
        "And I almost do not have words for it.",
      ],
      es: [
        "Hay una parte de mi que se cerro.",
        "Me siento lejos de lo que de verdad siento.",
        "Y casi no tengo palabras para eso.",
      ],
    },
  },
];

const DISCOVERY_MANIFESTATIONS = {
  relationship: {
    pain: [
      { key: "breakup", problemKey: "rel_breakup_fresh_pain", labels: { he: "הלב שלי נשבר", en: "My heart feels broken", es: "Siento el corazon roto" } },
      { key: "distance", problemKey: "romantic_loneliness", labels: { he: "מישהו התרחק ממני", en: "Someone moved away from me", es: "Alguien se alejo de mi" } },
      { key: "cannot_let_go", problemKey: "lack_of_closure_after_breakup", labels: { he: "אני לא מצליח לשחרר", en: "I cannot let go", es: "No logro soltar" } },
      { key: "still_looking", problemKey: "obsessive_longing", labels: { he: "אני עדיין מחפש אותה", en: "I still look for her", es: "Todavia la busco" } },
    ],
    fear: [
      { key: "abandonment", problemKey: "conditional_relationship_fear_of_abandonment", labels: { he: "אני מפחד שיעזבו אותי", en: "I am afraid they will leave me", es: "Tengo miedo de que me dejen" } },
      { key: "trust", problemKey: "lack_of_trust_in_relationship", labels: { he: "קשה לי לבטוח", en: "It is hard for me to trust", es: "Me cuesta confiar" } },
      { key: "hurt_again", problemKey: "fear_starting_relationship_dating_anxiety", labels: { he: "אני מפחד להיפגע שוב", en: "I am afraid of getting hurt again", es: "Tengo miedo de volver a salir herido" } },
      { key: "bad_relationship", problemKey: "fear_leaving_bad_relationship", labels: { he: "אני נשאר בקשר שלא טוב לי", en: "I stay in a relationship that hurts me", es: "Me quedo en una relacion que me hace mal" } },
    ],
    confusion: [
      { key: "same_loops", problemKey: "pursuer_distancer_cycle", labels: { he: "אני נתקע באותן לולאות", en: "I get stuck in the same loops", es: "Me quedo atrapado en los mismos ciclos" } },
      { key: "needs", problemKey: "difficulty_expressing_needs_and_boundaries_with_partner", labels: { he: "קשה לי להגיד מה אני צריך", en: "It is hard for me to say what I need", es: "Me cuesta decir lo que necesito" } },
      { key: "open_up", problemKey: "difficulty_opening_up_on_dates", labels: { he: "אני לא מצליח להיפתח", en: "I cannot open up", es: "No logro abrirme" } },
      { key: "destructive", problemKey: "repeated_attraction_to_destructive_partners", labels: { he: "אני נמשך שוב למי שפוגע בי", en: "I am drawn again to people who hurt me", es: "Vuelvo a acercarme a quien me hiere" } },
    ],
    loneliness: [
      { key: "alone_in_relationship", problemKey: "romantic_loneliness", labels: { he: "אני מרגיש לבד בתוך זה", en: "I feel alone inside this", es: "Me siento solo dentro de esto" } },
      { key: "no_one_sees_me", problemKey: "i_have_no_one_who_really_knows_me", labels: { he: "אין מי שבאמת רואה אותי", en: "No one really sees me", es: "Nadie me ve de verdad" } },
      { key: "afraid_alone", problemKey: "conditional_relationship_fear_of_abandonment", labels: { he: "אני מפחד להישאר לבד", en: "I am afraid to stay alone", es: "Tengo miedo de quedarme solo" } },
      { key: "missing_someone", problemKey: "obsessive_longing", labels: { he: "אני מתגעגע למישהו", en: "I miss someone", es: "Extrano a alguien" } },
    ],
    overthinking: [
      { key: "thinking_about_her", problemKey: "obsessive_longing", labels: { he: "אני חושב עליה כל הזמן", en: "I think about her all the time", es: "Pienso en ella todo el tiempo" } },
      { key: "analyzing", problemKey: "lack_of_closure_after_breakup", labels: { he: "אני מנתח כל דבר שקרה", en: "I analyze everything that happened", es: "Analizo todo lo que paso" } },
      { key: "checking", problemKey: "jealousy_ex_moves_on", labels: { he: "אני בודק מה קורה איתה", en: "I keep checking what is happening with her", es: "Sigo revisando que pasa con ella" } },
      { key: "replaying", problemKey: "lack_of_closure_after_breakup", labels: { he: "אני לא מפסיק לשחזר", en: "I cannot stop replaying it", es: "No puedo dejar de repasarlo" } },
    ],
    emptiness: [
      { key: "closed_since", problemKey: "lack_of_closure_after_breakup", labels: { he: "משהו בי נסגר מאז שזה קרה", en: "Something in me closed since it happened", es: "Algo en mi se cerro desde que paso" } },
      { key: "empty_in_relationship", problemKey: "romantic_loneliness", labels: { he: "אני מרגיש ריק בתוך זה", en: "I feel empty inside this", es: "Me siento vacio dentro de esto" } },
      { key: "no_strength", problemKey: "rel_breakup_fresh_pain", labels: { he: "אין לי כוח לזה יותר", en: "I do not have strength for this anymore", es: "Ya no tengo fuerza para esto" } },
      { key: "space_left", problemKey: "rel_breakup_fresh_pain", labels: { he: "נשאר בי חלל", en: "A space was left in me", es: "Quedo un vacio en mi" } },
    ],
  },
  self: {
    pain: [
      { key: "not_enough", problemKey: "i_am_not_enough", labels: { he: "אני לא מרגיש מספיק", en: "I do not feel like enough", es: "No siento que sea suficiente" } },
      { key: "hard_on_self", problemKey: "harsh_self_criticism", labels: { he: "אני קשה עם עצמי", en: "I am hard on myself", es: "Soy duro conmigo" } },
      { key: "failure", problemKey: "chronic_sense_of_failure", labels: { he: "אני מרגיש שנכשלתי", en: "I feel that I failed", es: "Siento que fracase" } },
      { key: "accept_self", problemKey: "difficulty_accepting_certain_parts_of_myself_sensitivity_weakness_inner_darkness", labels: { he: "קשה לי לקבל את עצמי", en: "It is hard for me to accept myself", es: "Me cuesta aceptarme" } },
    ],
    fear: [
      { key: "fear_fail", problemKey: "fear_of_failure", labels: { he: "אני מפחד להיכשל", en: "I am afraid of failing", es: "Tengo miedo de fracasar" } },
      { key: "fear_success", problemKey: "fear_of_success", labels: { he: "אני מפחד מהצלחה", en: "I am afraid of success", es: "Tengo miedo del exito" } },
      { key: "fear_rejection", problemKey: "fear_of_rejection", labels: { he: "אני מפחד שידחו אותי", en: "I am afraid of being rejected", es: "Tengo miedo de que me rechacen" } },
      { key: "must_be_perfect", problemKey: "need_to_be_perfect_in_everything", labels: { he: "אני מרגיש שאני חייב להיות מושלם", en: "I feel I must be perfect", es: "Siento que debo ser perfecto" } },
    ],
    confusion: [
      { key: "who_am_i", problemKey: "i_don_t_know_who_i_am_anymore", labels: { he: "אני לא יודע מי אני עכשיו", en: "I do not know who I am now", es: "No se quien soy ahora" } },
      { key: "lost_self", problemKey: "loss_of_sense_of_identity_who_am_i_even_today", labels: { he: "איבדתי את התחושה של עצמי", en: "I lost the sense of myself", es: "Perdi el sentido de mi mismo" } },
      { key: "life_confusion", problemKey: "confusion_about_the_choices_in_life_relationship_career_place_of_residence", labels: { he: "אני מבולבל לגבי החיים שלי", en: "I am confused about my life", es: "Estoy confundido con mi vida" } },
      { key: "society_expectations", problemKey: "a_conflict_between_who_i_really_am_and_what_society_expects", labels: { he: "אני חי לפי מה שמצפים ממני", en: "I live by what is expected of me", es: "Vivo segun lo que esperan de mi" } },
    ],
    loneliness: [
      { key: "no_one_knows", problemKey: "i_have_no_one_who_really_knows_me", labels: { he: "אף אחד לא באמת מכיר אותי", en: "No one really knows me", es: "Nadie me conoce de verdad" } },
      { key: "strange", problemKey: "feeling_strange_not_belong", labels: { he: "אני מרגיש זר ליד אנשים", en: "I feel strange around people", es: "Me siento extrano junto a la gente" } },
      { key: "always_listen", problemKey: "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me", labels: { he: "אני תמיד מקשיב לאחרים", en: "I am always the one who listens to others", es: "Siempre soy quien escucha a los demas" } },
      { key: "deep_friendship", problemKey: "difficulty_forming_deep_friendships", labels: { he: "קשה לי ליצור קשר עמוק", en: "It is hard for me to build deep connection", es: "Me cuesta crear un vinculo profundo" } },
    ],
    overthinking: [
      { key: "cannot_stop_thinking", problemKey: "overthinking_chronic_worry", labels: { he: "אני לא מפסיק לחשוב", en: "I cannot stop thinking", es: "No dejo de pensar" } },
      { key: "bad_scenarios", problemKey: "catastrophic_thoughts", labels: { he: "אני רואה תסריטים רעים", en: "I see bad scenarios", es: "Veo escenarios malos" } },
      { key: "checking_everything", problemKey: "anxiety_vigilance", labels: { he: "אני בודק הכול שוב", en: "I keep checking everything again", es: "Sigo revisando todo otra vez" } },
      { key: "replay_meeting", problemKey: "replay_after_meeting", labels: { he: "אני משחזר כל מפגש", en: "I replay every meeting", es: "Repaso cada encuentro" } },
    ],
    emptiness: [
      { key: "empty", problemKey: "feeling_of_inner_emptiness_i_have_no_energy_for_anything", labels: { he: "אני מרגיש ריק", en: "I feel empty", es: "Me siento vacio" } },
      { key: "no_energy", problemKey: "lack_of_desire_lack_of_motivation", labels: { he: "אין לי כוח לכלום", en: "I have no energy for anything", es: "No tengo energia para nada" } },
      { key: "fine_on_paper", problemKey: "everything_is_fine_on_paper_but_inside_is_empty", labels: { he: "הכול בסדר על הנייר אבל לא בפנים", en: "Everything is fine on paper but not inside", es: "Todo esta bien en el papel pero no por dentro" } },
      { key: "life_passed", problemKey: "the_feeling_of_life_passed_me_by", labels: { he: "עבר לי משהו מהחיים", en: "I feel life passed me by", es: "Siento que la vida paso de largo" } },
    ],
  },
  future: {
    fear: [
      { key: "future_itself", problemKey: "catastrophic_thoughts", labels: { he: "אני מפחד ממה שיקרה", en: "I am afraid of what will happen", es: "Tengo miedo de lo que pasara" } },
      { key: "alone_later", problemKey: "fear_of_being_alone_in_old_age", labels: { he: "אני מפחד להישאר לבד", en: "I am afraid of ending up alone", es: "Tengo miedo de quedarme solo" } },
      { key: "health", problemKey: "health_anxiety_every_symptom_a_movie_in_the_head", labels: { he: "אני מפחד על הבריאות שלי", en: "I am afraid about my health", es: "Tengo miedo por mi salud" } },
      { key: "money", problemKey: "financial_anxiety_debts", labels: { he: "אני מפחד להסתבך כלכלית", en: "I am afraid of financial collapse", es: "Tengo miedo de hundirme economicamente" } },
    ],
    confusion: [
      { key: "where_life_goes", problemKey: "confusion_about_the_choices_in_life_relationship_career_place_of_residence", labels: { he: "אני לא יודע לאן החיים שלי הולכים", en: "I do not know where my life is going", es: "No se hacia donde va mi vida" } },
      { key: "place", problemKey: "i_don_t_know_who_i_am_anymore", labels: { he: "אני לא בטוח איפה המקום שלי", en: "I am not sure where my place is", es: "No estoy seguro de cual es mi lugar" } },
      { key: "choices", problemKey: "confusion_about_the_choices_in_life_relationship_career_place_of_residence", labels: { he: "אני לא יודע מה לבחור", en: "I do not know what to choose", es: "No se que elegir" } },
      { key: "unclear_future", problemKey: "the_feeling_of_life_passed_me_by", labels: { he: "קשה לי לראות עתיד ברור", en: "It is hard for me to see a clear future", es: "Me cuesta ver un futuro claro" } },
    ],
    overthinking: [
      { key: "worst_case", problemKey: "catastrophic_thoughts", labels: { he: "אני רואה את הגרוע מכול", en: "I see the worst case first", es: "Veo primero lo peor" } },
      { key: "worry", problemKey: "overthinking_chronic_worry", labels: { he: "אני לא מפסיק לדאוג", en: "I cannot stop worrying", es: "No dejo de preocuparme" } },
      { key: "check_again", problemKey: "anxiety_vigilance", labels: { he: "אני בודק שוב ושוב מה יכול לקרות", en: "I keep checking what might happen", es: "Sigo revisando lo que podria pasar" } },
      { key: "giant_scenarios", problemKey: "catastrophic_thoughts", labels: { he: "כל תרחיש נהיה ענק", en: "Every scenario becomes huge", es: "Cada escenario se vuelve enorme" } },
    ],
  },
  past: {
    pain: [
      { key: "still_hurts", problemKey: "trauma_after_betrayal_extreme_abandonment", labels: { he: "משהו שקרה עדיין כואב לי", en: "Something that happened still hurts me", es: "Algo que paso todavia me duele" } },
      { key: "loss", problemKey: "loss_of_a_loved_one_death", labels: { he: "אני עדיין באבל על מה שאבד", en: "I am still grieving what was lost", es: "Todavia estoy de duelo por lo que perdi" } },
      { key: "cannot_release_past", problemKey: "lack_of_closure_after_breakup", labels: { he: "אני לא מצליח לשחרר את מה שהיה", en: "I cannot release what happened", es: "No logro soltar lo que paso" } },
      { key: "old_pain", problemKey: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable", labels: { he: "יש בי כאב ישן", en: "There is an old pain in me", es: "Hay un dolor viejo en mi" } },
    ],
    fear: [
      { key: "past_jumps", problemKey: "flashbacks_bad_dreams_chronic_stress", labels: { he: "העבר עדיין קופץ בי", en: "The past still jumps inside me", es: "El pasado todavia salta dentro de mi" } },
      { key: "alert_since", problemKey: "trauma_from_wars_disasters_accidents", labels: { he: "אני דרוך מאז מה שקרה", en: "I have been on alert since it happened", es: "Estoy en alerta desde que paso" } },
      { key: "trust_since", problemKey: "deep_distrust_in_humans_after_a_difficult_experience", labels: { he: "קשה לי לבטוח מאז", en: "It has been hard for me to trust since then", es: "Desde entonces me cuesta confiar" } },
      { key: "afraid_return", problemKey: "trauma_after_betrayal_extreme_abandonment", labels: { he: "אני מפחד שזה יחזור", en: "I am afraid it will happen again", es: "Tengo miedo de que vuelva" } },
    ],
    confusion: [
      { key: "still_understand", problemKey: "lack_of_closure_after_breakup", labels: { he: "אני עדיין מנסה להבין מה קרה", en: "I am still trying to understand what happened", es: "Todavia intento entender lo que paso" } },
      { key: "old_voices", problemKey: "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day", labels: { he: "אני מסתובב עם קולות ישנים", en: "I carry old voices inside me", es: "Camino con voces viejas dentro de mi" } },
      { key: "what_it_did", problemKey: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable", labels: { he: "אני לא יודע מה זה עשה לי", en: "I do not know what this did to me", es: "No se que me hizo esto" } },
      { key: "part_left_there", problemKey: "difficulty_forgiving_a_parent_for_the_past", labels: { he: "חלק ממני נשאר שם", en: "Part of me stayed there", es: "Una parte de mi se quedo alli" } },
    ],
  },
};

function getLangText(node, lang, fallback = "") {
  if (!node) return fallback;
  if (typeof node === "string") return node;
  return node[lang] || node.he || node.en || node.es || fallback;
}

export function getEntryCardLabel(entryKey, lang = "he") {
  return getLangText(
    ENTRY_EMOTION_CARDS.find((card) => card.key === entryKey)?.labels,
    lang,
    ""
  );
}

export function getEntryCards(lang = "he") {
  return ENTRY_EMOTION_CARDS.map((card) => ({
    key: card.key,
    problemKey: card.problemKey,
    label: getLangText(card.labels, lang, ""),
  }));
}

export function resolveEntryProblemKey(entryKey = "") {
  return ENTRY_EMOTION_CARDS.find((card) => card.key === entryKey)?.problemKey || "";
}

export function getRecognitionLines({ lang = "he", entryKey = "", problemKey = "", problemTitle = "" }) {
  const fromCard = ENTRY_EMOTION_CARDS.find((card) => card.key === entryKey);
  if (fromCard) {
    return fromCard.recognition[lang] || fromCard.recognition.he || [];
  }

  if (problemKey) {
    return getRecognitionLinesForProblem(problemKey, lang);
  }

  if (lang === "en") {
    return [
      "I pause for a moment with what I am carrying.",
      problemTitle ? `I came here with ${problemTitle.toLowerCase()}.` : "There is something in me asking for space.",
      "I let it be here for a moment.",
    ];
  }
  if (lang === "es") {
    return [
      "Me detengo un momento con lo que traigo.",
      problemTitle ? `Llegue aqui con ${problemTitle.toLowerCase()}.` : "Hay algo en mi que pide espacio.",
      "Le doy lugar por un momento.",
    ];
  }
  return [
    "אני עוצר רגע עם מה שבאתי איתו.",
    problemTitle ? `אני באתי לכאן עם ${problemTitle}.` : "יש בי משהו שמבקש מקום.",
    "אני נותן לזה להיות כאן לרגע.",
  ];
}

export function getEntryScreenCopy(lang = "he") {
  if (lang === "en") {
    return {
      landingLines: [
        "Welcome to InnerVoice",
        "You don't have to solve everything right now.",
        "Just pause for a moment.",
        "And listen to what you're going through.",
      ],
      landingCta: "Begin",
      selectionHeadline: "What feels closest to what I am going through right now?",
      selectionSub: "Pick a card that fits — or go below for the full catalog or a short guided chooser.",
      quickStartLabel: "Quick start",
      moreOptionsLabel: "Other ways in",
      discovery: "Not sure? A few short questions",
      explorer: "Full catalog (life areas → topics)",
      continue: "Continue",
      resumeWelcome: "Good to see you again — you are not doing this alone.",
      resume: "Continue my journey",
      chooseOther: "Start a different journey",
      waitingLine: "Your journey is still here, exactly where you paused.",
      resumeEncouragement:
        "One small step today is enough. The system will continue with you from where you left off.",
      dayWaiting: (day) => `Day ${day} is ready when you are`,
    };
  }
  if (lang === "es") {
    return {
      landingLines: [
        "Bienvenido a InnerVoice",
        "No tienes que resolverlo todo ahora.",
        "Solo detente un momento.",
        "Y escucha lo que te está pasando.",
      ],
      landingCta: "Empezar",
      selectionHeadline: "¿Qué se siente más cercano a lo que te pasa ahora?",
      selectionSub:
        "Elige una tarjeta que encaje, o ve abajo al catálogo completo o a unas preguntas guiadas breves.",
      discovery: "Todavía no estoy seguro",
      explorer: "Buscar un problema específico",
      continue: "Seguir",
      resumeWelcome: "Me alegra verte de nuevo — no estás solo/a en esto.",
      resume: "Seguir mi camino",
      chooseOther: "Empezar otro camino",
      waitingLine: "Tu camino sigue aquí, justo donde lo dejaste.",
      resumeEncouragement:
        "Hoy basta un paso pequeño. El sistema sigue contigo desde el punto en el que lo dejaste.",
      dayWaiting: (day) => `El día ${day} está listo cuando tú lo estés`,
    };
  }
  return {
    landingLines: [
      "ברוך הבא ל־InnerVoice",
      "לא צריך לפתור הכול עכשיו.",
      "רק לעצור לרגע",
      "ולהקשיב למה שעובר עליך.",
    ],
    landingCta: "להתחיל",
    selectionHeadline: "מה הכי קרוב למה שעובר עליך עכשיו?\u200F",
    selectionSub: "אפשר להתחיל ממה שהכי מדויק לך עכשיו, או לבחור מתוך הרשימה המלאה.",
    quickStartLabel: "בחר מה הכי קרוב אליך כרגע",
    moreOptionsLabel: "אפשרויות נוספות",
    discovery: "לא בטוח מאיפה להתחיל? נבחר יחד בכמה שאלות קצרות",
    explorer: "לרשימה המלאה של הנושאים",
    continue: "להמשיך",
    resumeWelcome: "טוב שחזרת — אנחנו כאן איתך, בלי לשפוט.",
    resume: "להמשיך את המסע שלי",
    chooseOther: "להתחיל במסע אחר",
    waitingLine: "המסע עדיין כאן, בדיוק איפה שעצרת.",
    resumeEncouragement: "מספיק צעד קטן היום. המערכת תמשיך איתך מנקודת ההמשך.",
    dayWaiting: (day) => `יום ${day} כבר מוכן בשבילך, בקצב שלך`,
  };
}

export function getDiscoveryQuestion1(lang = "he", gender = "other") {
  return {
    id: "source",
    prompt:
      lang === "en"
        ? "What feels most connected to what you are feeling now?"
        : lang === "es"
        ? "Que se relaciona mas con lo que sientes ahora?"
        : pickGenderText(
            {
              male: "מה הכי קרוב למה שאתה מרגיש עכשיו?\u200F",
              female: "מה הכי קרוב למה שאת מרגישה עכשיו?\u200F",
              other: "מה הכי קרוב למה שאתה מרגיש עכשיו?\u200F",
            },
            gender
          ),
    options: [
      {
        key: "relationship",
        label:
          lang === "he"
            ? "משהו שקרה ביני לבין מישהו אחר"
            : lang === "es"
              ? "Algo que paso con otra persona"
              : "Something that happened with another person",
      },
      {
        key: "self",
        label: lang === "he" ? "משהו שקורה בתוכי" : lang === "es" ? "Algo dentro de mi" : "Something inside me",
      },
      {
        key: "future",
        label:
          lang === "he"
            ? "משהו בעתיד שמפחיד אותי"
            : lang === "es"
              ? "Algo del futuro que me asusta"
              : "Something in the future that scares me",
      },
      {
        key: "past",
        label:
          lang === "he"
            ? "משהו מהעבר שלא עוזב אותי"
            : lang === "es"
              ? "Algo del pasado que no me suelta"
              : "Something in the past that does not leave me",
      },
      { key: "unclear", label: lang === "he" ? "אני לא בטוח" : lang === "es" ? "No estoy seguro" : "I am not sure" },
    ],
  };
}

export function getDiscoveryQuestion2(lang = "he", gender = "other") {
  return {
    id: "feeling",
    prompt:
      lang === "en"
        ? "What feels closest to the main feeling?"
        : lang === "es"
        ? "Que se siente mas cerca de la sensacion central?"
        : pickGenderText(
            {
              male: "מה הכי קרוב לתחושה המרכזית שאתה מרגיש?",
              female: "מה הכי קרוב לתחושה המרכזית שאת מרגישה?",
              other: "מה הכי קרוב לתחושה המרכזית שאתה מרגיש?",
            },
            gender
          ),
    options: [
      { key: "pain", label: lang === "he" ? "כאב" : lang === "es" ? "Dolor" : "Pain" },
      { key: "fear", label: lang === "he" ? "פחד" : lang === "es" ? "Miedo" : "Fear" },
      { key: "confusion", label: lang === "he" ? "בלבול" : lang === "es" ? "Confusion" : "Confusion" },
      { key: "loneliness", label: lang === "he" ? "בדידות" : lang === "es" ? "Soledad" : "Loneliness" },
      { key: "overthinking", label: lang === "he" ? "מחשבות שלא מפסיקות" : lang === "es" ? "Pensamientos que no paran" : "Thoughts that do not stop" },
      { key: "emptiness", label: lang === "he" ? "ריקנות" : lang === "es" ? "Vacio" : "Emptiness" },
    ],
  };
}

export function getDiscoveryQuestion3({ lang = "he", source = "", feeling = "" }) {
  const options =
    DISCOVERY_MANIFESTATIONS[source]?.[feeling] ||
    DISCOVERY_MANIFESTATIONS[source]?.fear ||
    DISCOVERY_MANIFESTATIONS.self?.[feeling] ||
    DISCOVERY_MANIFESTATIONS.self?.confusion ||
    [];

  return {
    id: "manifestation",
    prompt:
      lang === "en"
        ? "What describes what is happening best?"
        : lang === "es"
        ? "Que describe mejor lo que te esta pasando?"
        : "מה הכי מתאר את מה שקורה לך?",
    options: options.map((option) => ({
      key: option.key,
      problemKey: option.problemKey,
      label: getLangText(option.labels, lang, ""),
    })),
  };
}

export function resolveDiscoveryProblemKey({ source = "", feeling = "", manifestation = "" }) {
  const options =
    DISCOVERY_MANIFESTATIONS[source]?.[feeling] ||
    DISCOVERY_MANIFESTATIONS[source]?.fear ||
    DISCOVERY_MANIFESTATIONS.self?.[feeling] ||
    DISCOVERY_MANIFESTATIONS.self?.confusion ||
    [];
  return options.find((option) => option.key === manifestation)?.problemKey || "";
}
